import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Step16View from './Step16-view';
import config from '../../config/common';
import {clearSessionStorage} from '../../utils/sessionStorage';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const placeholderEmail = 'yourmail@mail.com';

const Step16 = ({checkAgentId, payload, regType}) => {
  const {formatMessage} = useIntl();
  useEffect(() => {
    let timerId = null;

    const checkAgentIdAndRedirect = () => {
      checkAgentId({regType})
        .then(agentId => {
          if (agentId) {
            if (timerId) clearTimeout(timerId);
            clearSessionStorage();
            window.location.href = `${config.client.href}`
          } else {
            timerId = setTimeout(checkAgentIdAndRedirect, config.api.timeout.agentId);
          }
        })
        .then(() => trackEvent('signup_step',
            {
              step_number: 16,
              step_name_en: 'Final',
              step_name_he: formatMessage({id: 'step16.page.title', defaultMessage: ''}),
              regType
            }
          )
        )
    };

    checkAgentIdAndRedirect()
  }, []);

  return (
    <Step16View email={payload.userMail || placeholderEmail}/>
  )
};

Step16.propTypes = {
  regType: PropTypes.string,
  payload: PropTypes.object,
  submitStep: PropTypes.func,
  checkAgentId: PropTypes.func
};

export default Step16;
